import React from 'react';
import { Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Profile } from './Profile';
import { Orders } from './Orders';
import { User, ShoppingBag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UserPortal() {
  const { profile } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (!profile || profile.role !== 'customer') {
    return <Navigate to="/" replace />;
  }

  const navigation = [
    { name: t('common.profile'), to: '/account/profile', icon: User },
    { name: t('common.orders'), to: '/account/orders', icon: ShoppingBag }
  ];

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-gray-100">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="lg:grid lg:grid-cols-12 lg:gap-x-5">
          <aside className="py-6 px-2 sm:px-6 lg:col-span-3 lg:py-0 lg:px-0">
            <nav className="space-y-1">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.to}
                  className={
                    `group flex items-center px-3 py-2 text-sm font-medium rounded-md ${
                      location.pathname === item.to
                        ? 'bg-gray-50 text-green-700 hover:text-green-700 hover:bg-white'
                        : 'text-gray-900 hover:text-gray-900 hover:bg-gray-50'
                    }`
                  }
                >
                  <item.icon
                    className={`flex-shrink-0 -ml-1 mr-3 h-6 w-6 ${
                      location.pathname === item.to
                        ? 'text-green-500'
                        : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  <span className="truncate">{item.name}</span>
                </Link>
              ))}
            </nav>
          </aside>

          <div className="space-y-6 sm:px-6 lg:col-span-9 lg:px-0">
            <div className="shadow sm:rounded-md sm:overflow-hidden bg-white p-6">
              <Routes>
                <Route path="profile" element={<Profile />} />
                <Route path="orders" element={<Orders />} />
                <Route path="*" element={<Navigate to="/account/profile" replace />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 